// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e965e8d","917":"551e2632"}[chunkId] + ".chunk.js";
};